import { handleActions } from "redux-actions";

import {
    setViewResultsDialog,
    mergeViewResultsDialog,
    mergeSourceResultsDialog,
    setSourceResultsDialog,
    setStatusHistoryDialog,
    mergeStatusHistoryDialog,
    setTrackTree,
    mergeTrackTree,
    setMetadata,
    setBuffer,
    setViewScrapeAttemptsDialog,
    mergeViewScrapeAttemptsDialog,
    setDownloadResultObjectsDialog,
    mergeDownloadResultObjectsDialog
} from "./actions";

const initialState = {
    viewResultsDialog: {
        id: null,
        isOpen: false,
        isLoading: false,
        track_id: null,
        scraped_result_objects: null,
        object_structures: null,
    },
    viewScrapeAttemptsDialog: {
        id: null,
        isOpen: false,
        isLoading: false,
        scrapeAttempts: null
    },
    viewSourceDialog: {
        id: null,
        isOpen: false,
        isLoading: false,
        sourceTrack: {}
    },
    statusHistory: {
        id: null,
        isOpen: false,
        isLoading: false,
        history: {}
    },
    trackTree: {
        isLoading: false,
        statusType: null,
        trackTree: null
    },
    viewMetadataDialog: {
        isOpen: false,
        isLoading: false,
        track_id: null,
        metadata: null
    },
    viewBufferDialog: {
        isOpen: false,
        task: {}
    },
    downloadDialog: {
        isOpen: false,
        isLoading: false,
        status: null,
        url: null
    },
};

export const actionsInfoReducer = handleActions(
    {
        [setViewResultsDialog]: (state, { payload }) => ({
            ...state,
            viewResultsDialog: {
                ...initialState.viewResultsDialog,
                ...payload
            }
        }),
        [mergeViewResultsDialog]: (state, { payload }) => ({
            ...state,
            viewResultsDialog: {
                ...state.viewResultsDialog,
                ...payload
            }
        }),
        [setViewScrapeAttemptsDialog]: (state, { payload }) => ({
            ...state,
            viewScrapeAttemptsDialog: {
                ...initialState.viewScrapeAttemptsDialog,
                ...payload
            }
        }),
        [mergeViewScrapeAttemptsDialog]: (state, { payload }) => ({
            ...state,
            viewScrapeAttemptsDialog: {
                ...state.viewScrapeAttemptsDialog,
                ...payload
            }
        }),

        [setSourceResultsDialog]: (state, { payload }) => ({
            ...state,
            viewSourceDialog: {
                ...initialState.viewSourceDialog,
                ...payload
            }
        }),
        [mergeSourceResultsDialog]: (state, { payload }) => ({
            ...state,
            viewSourceDialog: {
                ...state.viewSourceDialog,
                ...payload
            }
        }),

        [setMetadata]: (state, { payload }) => ({
            ...state,
            viewMetadataDialog: {
                ...initialState.viewMetadataDialog,
                ...payload
            }
        }),

        [setBuffer]: (state, { payload }) => ({
            ...state,
            viewBufferDialog: {
                ...initialState.viewBufferDialog,
                ...payload
            }
        }),

        [setStatusHistoryDialog]: (state, { payload }) => ({
            ...state,
            statusHistory: {
                ...initialState.statusHistory,
                ...payload
            }
        }),
        [mergeStatusHistoryDialog]: (state, { payload }) => ({
            ...state,
            statusHistory: {
                ...state.statusHistory,
                ...payload
            }
        }),

        [setTrackTree]: (state, { payload }) => ({
            ...state,
            trackTree: {
                ...initialState.trackTree,
                ...payload
            }
        }),
        [mergeTrackTree]: (state, { payload }) => ({
            ...state,
            trackTree: {
                ...state.trackTree,
                ...payload
            }
        }),

        [setDownloadResultObjectsDialog]: (state, { payload }) => ({
            ...state,
            downloadDialog: {
                ...initialState.downloadDialog,
                ...payload
            }
        }),
        [mergeDownloadResultObjectsDialog]: (state, { payload }) => ({
            ...state,
            downloadDialog: {
                ...state.downloadDialog,
                ...payload
            }
        })
    },
    initialState
);
